import React, { useEffect, useState } from "react";
import MainConteiner from "../components/partials/maincontainer";
import Input from "../components/partials/inputs";
import PrimaryBtn from "../components/partials/btn";
import SuccessModal from "../components/modals/successmodal";
import { Controller, useForm } from "react-hook-form";
import { apiCall, useApiCall } from "../data/useFetcher";
import { useRequestStore } from "../data/stores/loggerStore";
import useAuthStore from "../data/stores/authStore";

export const MainRecommendations = ({ title }: { title?: string }) => {
  const [modal, setModal] = useState(false);
  const Arr: Array<{
      label: string;
      placeholder: string;
      footer?: string;
      name: "organizationName" | "email" | "description" | "country";
    }> = [
      {
        label: "Enter Organisation Name*",
        placeholder: "Enter Organisation",
        footer: "Do not enter abbreviations",
        name: "organizationName",
      },
      {
        label: "Enter Focal Person Email*",
        placeholder: "Enter Email",
        name: "email",
      },
      {
        label: "Tell us a bit about the organisation*",
        placeholder: "Enter Here",
        name: "description",
      },
      {
        label: "Country of Operation*",
        placeholder: "Country",
        name: "country",
      },
    ],
    { getDynamicLogger, regionCountry }: any = useRequestStore();

  useEffect(() => {
    apiCall({
      type: "get",
      url: `/api/v1/data-system/manage-region-country?pagination=not&useHardCoded=true`,
      getter: (d: any) => getDynamicLogger(d, "regionCountry"),
    });
  }, []);

  interface FormType {
    email: string;
    organizationName: string;
    country: string;
  }

  const {
      control,
      handleSubmit,
      formState: { errors },
    } = useForm({
      defaultValues: {
        organizationName: "",
        email: "",
        country: "",
        description: "",
      },
    }),
    { onSubmitAPI, loading } = useApiCall(),
    { user, isAuth } = useAuthStore();

  const onSubmit = async (data: FormType) => {
    await onSubmitAPI({
      url: `/api/v1/auth/recommendation${
        isAuth && user ? "" : "/request-account"
      }`,
      type: "post",
      data: { members: [data] },
      toggleModal: () => {
        setModal(true);
      },
    });
  };

  return (
    <div>
      <MainConteiner>
        <div
          className={`${
            isAuth && user ? "" : "flex justify-center items-center"
          }`}
        >
          <div className={``}>
            <h3 className="text-2xl text-sec font-semibold">
              {title || "Recommendation"}
            </h3>
            <p className="text-base font-normal mt-4 max-w-sm text-[#667085]">
              {title === "Request"
                ? `Send a request to ESAWAS to make use of the Data Systems Maturity Assessment.`
                : `Do you know any organisation who will benefit greatly from this
							platform?`}
            </p>
            <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
              <div className="space-y-4 w-96">
                {Arr?.map((it) => (
                  <div>
                    <Controller
                      name={it?.name}
                      control={control}
                      rules={{
                        required: "This field is required",
                        pattern:
                          it.name === "email"
                            ? {
                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: "Invalid email format",
                              }
                            : null,
                      }}
                      render={({ field: { value, onChange, name } }) => (
                        <Input
                          type={
                            it?.name === "email"
                              ? "email"
                              : it?.name === "country"
                              ? "select"
                              : "text"
                          }
                          value={value}
                          onChange={onChange}
                          placeholder={it?.placeholder}
                          label={it?.label}
                          name={name}
                          options={regionCountry?.docs
                            ?.find((it: any) => it?.category === "COUNTRY")
                            ?.data?.sort(
                              (
                                a: { title: { toString: () => string } },
                                b: { title: { toString: () => any } }
                              ) => {
                                // Compare the values of the specified key in a case-insensitive manner
                                return a?.title
                                  ?.toString()
                                  ?.localeCompare(b?.title?.toString());
                              }
                            )
                            ?.map((it: any) => {
                              return {
                                ...it,
                                _id: it?.title,
                              };
                            })}
                        />
                      )}
                    />
                    {errors?.[it?.name] && (
                      <p className="text-[#dc2626] text-xs">
                        {errors?.[it?.name].message}
                      </p>
                    )}
                  </div>
                  // <Input
                  //   label={it?.label}
                  //   placeholder={it?.placeholder}
                  //   footer={it?.footer}
                  // />
                ))}
              </div>
              <div className="mt-8">
                <PrimaryBtn
                  // onClick={() => setModal(true)}
                  text="Continue"
                  width="w-96"
                  loading={!!loading}
                  type="submit"
                />
              </div>
            </form>
          </div>
        </div>
      </MainConteiner>
      {modal && (
        <SuccessModal
          page="/"
          title={`${title || "Recommendation"} Submission Completed`}
          desc="Thanks for completing the submission."
        />
      )}
    </div>
  );
};

const Recommendations = () => <MainRecommendations />;

export default Recommendations;
